import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser'

/**
 * Safe pipe. Examples of usage:
 * <p [innerHTML]="htmlContent | gbSafe: 'html'"></p>
 * <div [style.background-image]="'url(' + imgUrl + ')' | gbSafe: 'style'"></div>
 * <script [src]="scriptSrc | gbSafe: 'script'"></script>
 * <img [src]="imgUrl | gbSafe: 'url'">
 * <iframe [src]="catVideoEmbed | gbSafe: 'resourceUrl'"></iframe>
 */
@Pipe({
  name: 'gbSafe',
  pure: true,
})
export class GbSafePipe implements PipeTransform {
  constructor(protected _sanitizer: DomSanitizer) {}

  public transform(
    value: string | undefined,
    type: string,
  ): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    if (!value) return ''

    switch (type) {
      case 'html':
        return this._sanitizer.bypassSecurityTrustHtml(value)
      case 'style':
        return this._sanitizer.bypassSecurityTrustStyle(value)
      case 'script':
        return this._sanitizer.bypassSecurityTrustScript(value)
      case 'url':
        return this._sanitizer.bypassSecurityTrustUrl(value)
      case 'resourceUrl':
        return this._sanitizer.bypassSecurityTrustResourceUrl(value)
      default:
        throw new Error(`Invalid safe type specified: ${type}`)
    }
  }
}
